<div class="container-fullwidth body-con">



</div>


<router-outlet></router-outlet>
